import React from 'react';
import { makeStyles } from '@mui/styles';
import { Typography, Box, Chip, Grid, Tab, Tabs, Badge } from '@mui/material';
import { ReferenceManyField, SingleFieldList, TextField, ShowController, useTranslate, usePermissions } from 'react-admin';
import FileListButton from '../devices/Buttons/FileListDialog';
import NoteButton from '../devices/Buttons/NoteDialog';

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: 'auto',
        margin: 'auto',
    },
    innergrid: {
        maxWidth: 500,
        minHeight: 40,
    },
    card: {
        minWidth: 275,
        width: 'auto',
        margin: 'auto',
    },
    title: {
        fontSize: 14,
    }
}));

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            inert={value !== index ? "true" : undefined}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

const DeviceShow = ({ ...props }) => {
    const [value, setValue] = React.useState(0);
    const classes = useStyles();
    const translate = useTranslate();

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const permissions = usePermissions().permissions;

    const generateChip = (mag, key) => {
        if (mag !== "") {
            if (mag.indexOf(":") > 1) {
                let counter = mag.split(":")[1];
                let nmu = mag.split(":")[0];
                return (
                    <Badge badgeContent={counter} color="primary" size="small" sx={{ marginRight: '0.8rem', marginTop: '0.5rem' }} key={key}>
                        <Chip label={nmu} size="small" />
                    </Badge>
                );
            } else {
                return <Chip label={mag} size="small" sx={{ marginRight: '2px' }} key={key} />;
            }
        } else return null;
    };

    return (
        <ShowController {...props} title=" ">
            {({ record }) => {
                if (!record) return null; // Ensure something is returned

                return (
                    <>
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <Grid container spacing={2} >
                                <Grid item xs={9}>
                                    <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                                        <Tab label="Dati Materiale" {...a11yProps(0)} />
                                        <Tab label="Dati WR" {...a11yProps(1)} />
                                        <Tab label="Fonte DigiGEM" {...a11yProps(2)} />
                                        <Tab label="Altre Fonti" {...a11yProps(3)} />
                                    </Tabs>

                                </Grid>
                                <Grid item xs={3}>
                                    <Grid container>
                                        <Grid className={classes.innergrid} item xs={6}>
                                            <Typography className={classes.title} color="textSecondary" variant="body1" align="left">
                                                {translate('resources.devices.fields.updatedAt')}
                                            </Typography>
                                            <Typography variant="body2" align="left" type="datetime-local">
                                                {returnDate(record.updatedAt)}
                                            </Typography>
                                        </Grid>
                                        <Grid className={classes.innergrid} item xs={6}>
                                            <Typography className={classes.title} color="textSecondary" variant="body1" >
                                                {translate('resources.devices.fields.updatedBy')}
                                            </Typography>
                                            <Typography variant="body2"  >
                                                {record.updatedBy}
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Box>


                        <CustomTabPanel value={value} index={0}>
                            <Grid container spacing={1}>
                                <Grid className={classes.innergrid} item xs={3}>
                                    <Typography className={classes.title} color="textSecondary" variant="body1" >{translate('resources.devices.fields.serial_number_forn')}</Typography>
                                    <Typography variant="body2"  >{record.serial_number_forn}</Typography>
                                </Grid>
                                <Grid className={classes.innergrid} item xs={3}>
                                    <Typography className={classes.title} color="textSecondary" variant="body1" >{translate('resources.devices.fields.mac_address')}</Typography>
                                    <Typography variant="body2"  >{record.mac_address}</Typography>
                                </Grid>
                                <Grid className={classes.innergrid} item xs={3}>
                                    <Typography className={classes.title} color="textSecondary" variant="body1" >{translate('resources.devices.fields.num_consegna')}</Typography>
                                    <Typography variant="body2" >{record.num_consegna}</Typography>
                                </Grid>
                                <Grid className={classes.innergrid} item xs={3}>
                                    <Typography className={classes.title} color="textSecondary" variant="body1" >{translate('resources.devices.fields.num_consegna_orig')}</Typography>
                                    <Typography variant="body2" >{record.num_consegna_orig}</Typography>
                                </Grid>
                                <Grid className={classes.innergrid} item xs={3}>
                                    <Typography className={classes.title} color="textSecondary" variant="body1" >{translate('resources.devices.fields.codice_magazzino')}</Typography>
                                    <Typography variant="body2"  >{record.codice_magazzino}</Typography>
                                </Grid>
                                <Grid className={classes.innergrid} item xs={3}>
                                    <Typography className={classes.title} color="textSecondary" variant="body1" >{translate('resources.devices.fields.divisione')}</Typography>
                                    <Typography variant="body2"  >{record.divisione}</Typography>
                                </Grid>
                                <Grid className={classes.innergrid} item xs={3}>
                                    <Typography className={classes.title} color="textSecondary" variant="body1" >{translate('resources.devices.fields.cod_terr_sap_mos')}</Typography>
                                    <Typography variant="body2" >{record.cod_terr_sap_mos}</Typography>
                                </Grid>
                                <Grid className={classes.innergrid} item xs={3}>
                                    <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                        {translate('resources.magmois.fields.codice_impresa_desc')}
                                    </Typography>
                                    <ReferenceManyField
                                        resource="devices"
                                        reference="magmois"
                                        target="cod_terr_sap"
                                        source="cod_terr_sap"
                                        basePath="/devices"
                                        record={record}
                                        linkType={false}
                                    >
                                        <SingleFieldList linkType={false}>
                                            <TextField source="codice_impresa_desc" />
                                        </SingleFieldList>
                                    </ReferenceManyField>
                                </Grid>
                                <Grid className={classes.innergrid} item xs={3}>
                                    <Typography className={classes.title} color="textSecondary" variant="body1" >{translate('resources.nomenclatores.fields.desc_nmu')}</Typography>
                                    <ReferenceManyField resource="devices" reference="nomenclatores" target="cod_nmu" source="cod_nmu" basePath="/devices" record={record} linkType={false} >
                                        <SingleFieldList linkType={false}><TextField source="desc_nmu" /></SingleFieldList>
                                    </ReferenceManyField>
                                </Grid>
                                <Grid className={classes.innergrid} item xs={3}>
                                    <Typography className={classes.title} color="textSecondary" variant="body1" >{translate('resources.devices.fields.tipo_famiglia')}</Typography>
                                    <Typography variant="body2"  >{record.tipo_famiglia ? record.tipo_famiglia : 'Router'}</Typography>
                                </Grid>
                                <Grid className={classes.innergrid} item xs={3}>
                                    <Typography className={classes.title} color="textSecondary" variant="body1" >{translate('resources.devices.fields.cod_gruppo_tec')}</Typography>
                                    <Typography variant="body2"  >{record.cod_gruppo_tec}</Typography>
                                </Grid>
                                <Grid className={classes.innergrid} item xs={3}>
                                    <Typography className={classes.title} color="textSecondary" variant="body1" >{translate('resources.devices.fields.cod_stato_uso.codice')}</Typography>
                                    <Typography align="left" width="auto" variant="body1" >{record.cod_stato_uso ? record.cod_stato_uso.descrizione : undefined}</Typography>
                                </Grid>
                                <Grid className={classes.innergrid} item xs>
                                    <Typography className={classes.title} color="textSecondary" variant="body1" gutterBottom>
                                        {translate('resources.nomenclatores.fields.divresp')}
                                    </Typography>
                                    <ReferenceManyField
                                        resource="devices"
                                        reference="nomenclatores"
                                        target="cod_nmu"
                                        source="cod_nmu"
                                        basePath="/devices"
                                        record={record}
                                        linkType={false}
                                    >
                                        <SingleFieldList linkType={false}>
                                            <TextField source="divresp" />
                                        </SingleFieldList>
                                    </ReferenceManyField>
                                </Grid>
                            </Grid>
                        </CustomTabPanel>

                        <CustomTabPanel value={value} index={1}>
                            <Grid container spacing={1}>
                                <Grid className={classes.innergrid} item xs={3}>
                                    <Typography className={classes.title} color="textSecondary" variant="body1" >{translate('resources.devices.fields.area')}</Typography>
                                    <Typography variant="body2" >{record.area}</Typography>
                                </Grid>
                                <Grid className={classes.innergrid} item xs={3}>
                                    <Typography className={classes.title} color="textSecondary" variant="body1" >{translate('resources.devices.fields.data_completamento_wr')}</Typography>
                                    <Typography variant="body2" >{returnDate(record.data_completamento_wr)}</Typography>
                                </Grid>
                                <Grid className={classes.innergrid} item xs={3}>
                                    <Typography className={classes.title} color="textSecondary" variant="body1" >{translate('resources.devices.fields.cod_proj')}</Typography>
                                    <Typography variant="body2" >{record.cod_proj}</Typography>
                                </Grid>
                                <Grid className={classes.innergrid} item xs={3}>
                                    <Typography className={classes.title} color="textSecondary" variant="body1" >{translate('resources.devices.fields.equivalenza_prod_applicabile')}</Typography>
                                    <Typography variant="body2" >{record.equivalenza_prod_applicabile}</Typography>
                                </Grid>
                                <Grid className={classes.innergrid} item xs={3}>
                                    <Typography className={classes.title} color="textSecondary" variant="body1" >{translate('resources.devices.fields.flag_olo')}</Typography>
                                    <Typography variant="body2" >{record.flag_olo}</Typography>
                                </Grid>
                                <Grid className={classes.innergrid} item xs={3}>
                                    <Typography className={classes.title} color="textSecondary" variant="body1" >{translate('resources.devices.fields.tipo_task')}</Typography>
                                    <Typography variant="body2" >{record.tipo_task}</Typography>
                                </Grid>
                                <Grid className={classes.innergrid} item xs={3}>
                                    <Typography className={classes.title} color="textSecondary" >{translate('resources.devices.fields.codice_impresa_name')}</Typography>
                                    <Typography variant="body2"  >{record.codice_impresa_name}</Typography>
                                </Grid>
                                <Grid className={classes.innergrid} item xs={3}>
                                    <Typography className={classes.title} color="textSecondary" variant="body1" >{translate('resources.devices.fields.descrizione_impresa')}</Typography>
                                    <Typography variant="body2" >{record.descrizione_impresa}</Typography>
                                </Grid>
                                <Grid className={classes.innergrid} item xs={3}>
                                    <Typography className={classes.title} color="textSecondary" variant="body1" >{translate('resources.devices.fields.impianto')}</Typography>
                                    <Typography variant="body2"  >{record.impianto}</Typography>
                                </Grid>
                                <Grid className={classes.innergrid} item xs={3}>
                                    <Typography className={classes.title} color="textSecondary" variant="body1" >{translate('resources.devices.fields.resource_id')}</Typography>
                                    <Typography variant="body2" >{record.resource_id}</Typography>
                                </Grid>
                                <Grid className={classes.innergrid} item xs={3}>
                                    <Typography className={classes.title} color="textSecondary" variant="body1" >{translate('resources.devices.fields.client_type')}</Typography>
                                    <Typography variant="body2" >{record.client_type}</Typography>
                                </Grid>
                                <Grid className={classes.innergrid} item xs={3}>
                                    <Typography className={classes.title} color="textSecondary" variant="body1" >{translate('resources.devices.fields.wr_prodotti')}</Typography>
                                    <Typography variant="body2" >{record.wr_prodotti !== undefined ? record.wr_prodotti.toString() : undefined}</Typography>
                                </Grid>
                                <Grid className={classes.innergrid} item xs={3}>
                                    <Typography className={classes.title} color="textSecondary" >{translate('resources.devices.fields.lista_NMU')}</Typography>
                                    <Box>{record.lista_NMU ? record.lista_NMU.split(',').map((mag, i) => generateChip(mag, i))
                                        : undefined}</Box>
                                </Grid>
                                <Grid className={classes.innergrid} item xs={3}>
                                    <Typography className={classes.title} color="textSecondary" variant="body1" >{translate('resources.devices.fields.codice_isp')}</Typography>
                                    <Typography variant="body2" >{record.codice_isp}</Typography>
                                </Grid>
                                <Grid className={classes.innergrid} item xs={3}>
                                    <Typography className={classes.title} color="textSecondary" variant="body1" >{translate('resources.devices.fields.tsys')}</Typography>
                                    <Typography variant="body2" >{record.tsys}</Typography>
                                </Grid>
                                {(permissions === 'administrator' || permissions === 'approvatore' || permissions === 'dg') && (<>
                                    <Grid className={classes.innergrid} item xs={3}>
                                        <Typography className={classes.title} color="textSecondary" variant="body1" >{translate('resources.devices.fields.codice_riscontro')}</Typography>
                                        <Typography variant="body2" >{record.codice_riscontro}</Typography>
                                    </Grid>
                                </>)}
                                <Grid className={classes.innergrid} item xs={3}>
                                    <Typography className={classes.title} color="textSecondary" variant="body1" >{translate('resources.devices.fields.blinda_scarico_mat')}</Typography>
                                    <Typography variant="body2" >{record.blinda_scarico_mat}</Typography>
                                </Grid>
                                <Grid className={classes.innergrid} item xs={3}>
                                    <Typography className={classes.title} color="textSecondary" variant="body1" >{translate('resources.devices.fields.proprieta_materiale')}</Typography>
                                    <Typography variant="body2" >{record.proprieta_materiale}</Typography>
                                </Grid>
                                <Grid className={classes.innergrid} item xs={3}>
                                    <Typography className={classes.title} color="textSecondary" variant="body1" >{translate('resources.devices.fields.one_step')}</Typography>
                                    <Typography variant="body2" >{record.one_step}</Typography>
                                </Grid>
                            </Grid>
                        </CustomTabPanel>

                        <CustomTabPanel value={value} index={2}>
                            <Grid container spacing={1}>
                                <Grid className={classes.innergrid} item xs={3}>
                                    <Typography className={classes.title} color="textSecondary" variant="body1" align="left">{translate('resources.devices.fields.createdBy')}</Typography>
                                    <Typography variant="body2" align="left">{record.createdBy}</Typography>
                                </Grid>
                                <Grid className={classes.innergrid} item xs={3}>
                                    <Typography className={classes.title} color="textSecondary" >{translate('resources.devices.fields.createdAt')}</Typography>
                                    <Typography variant="body2"  >{returnDate(record.createdAt)}</Typography>
                                </Grid>
                                <Grid className={classes.innergrid} item xs={3}>
                                    <Typography className={classes.title} color="textSecondary" variant="body1" >{translate('resources.devices.fields.status.descrizione')}</Typography>
                                    <Typography variant="body2" >{record.status ? record.status.descrizione : undefined}</Typography>
                                </Grid>
                                <Grid className={classes.innergrid} item xs={3}>
                                    <Typography className={classes.title} color="textSecondary" variant="body1" >{translate('resources.devices.fields.associated_at')}</Typography>
                                    <Typography variant="body2" >{returnDate(record.associated_at)}</Typography>
                                </Grid>
                                <Grid className={classes.innergrid} item xs={3}>
                                    <Typography className={classes.title} color="textSecondary" variant="body1" >{translate('resources.devices.fields.associated_by')}</Typography>
                                    <Typography variant="body2" >{record.associated_by}</Typography>
                                </Grid>
                                <Grid className={classes.innergrid} item xs={3}>
                                    <Typography className={classes.title} color="textSecondary" variant="body1" >{translate('resources.devices.fields.progetto_con_scarico')}</Typography>
                                    <Typography variant="body2" >{record.progetto_con_scarico}</Typography>
                                </Grid>
                                <Grid className={classes.innergrid} item xs={3}>
                                    <Typography className={classes.title} color="textSecondary" variant="body1" >{translate('resources.devices.fields.anomalia.descrizione')}</Typography>
                                    <Typography variant="body2" >{record.anomalia ? record.anomalia.descrizione : undefined}</Typography>
                                </Grid>
                                <Grid className={classes.innergrid} item xs={3}>
                                    <Typography className={classes.title} color="textSecondary" variant="body1" >{translate('resources.devices.fields.status_regman.descrizione')}</Typography>
                                    <Typography variant="body2"  >{record.status_regman ? record.status_regman.descrizione : undefined}</Typography>
                                </Grid>
                                <Grid className={classes.innergrid} item xs={3}>
                                    <Typography className={classes.title} color="textSecondary" variant="body1" >{translate('resources.devices.fields.validated_at')}</Typography>
                                    <Typography variant="body2" >{returnDate(record.validated_at)}</Typography>
                                </Grid>
                                <Grid className={classes.innergrid} item xs={3}>
                                    <Typography className={classes.title} color="textSecondary" variant="body1" >{translate('resources.devices.fields.validated_by')}</Typography>
                                    <Typography variant="body2" >{record.validated_by}</Typography>
                                </Grid>
                                <Grid className={classes.innergrid} item xs={3}>
                                    <Typography className={classes.title} color="textSecondary" variant="body1" >{translate('resources.devices.fields.sent_to_sap')}</Typography>
                                    <Typography variant="body2" >{returnDate(record.sent_to_sap)}</Typography>
                                </Grid>
                                <Grid className={classes.innergrid} item xs={3}>
                                    <Typography className={classes.title} color="textSecondary" variant="body1" >{translate('resources.devices.fields.approved_at')}</Typography>
                                    <Typography variant="body2" >{returnDate(record.approved_at)}</Typography>
                                </Grid>
                                <Grid className={classes.innergrid} item xs={3}>
                                    <Typography className={classes.title} color="textSecondary" variant="body1" >{translate('resources.devices.fields.approved_by')}</Typography>
                                    <Typography variant="body2" >{record.approved_by}</Typography>
                                </Grid>
                                <Grid className={classes.innergrid} item xs={3}>
                                    <Typography className={classes.title} color="textSecondary" >{translate('resources.devices.fields.check_NMU')}</Typography>
                                    <Typography variant="body2"  >{record.check_NMU}</Typography>
                                </Grid>
                                <Grid className={classes.innergrid} item xs={3}>
                                    <Typography className={classes.title} color="textSecondary" variant="body1" >{translate('resources.devices.fields.check_u0009t')}</Typography>
                                    <Typography variant="body2" >{record.check_u0009t}</Typography>
                                </Grid>
                                {(permissions === 'administrator' || permissions === 'approvatore') && (<>
                                    <Grid className={classes.innergrid} item xs={3}>
                                        <Typography className={classes.title} color="textSecondary" variant="body1" >{translate('resources.devices.fields.causale_addebito.descrizione')}</Typography>
                                        <Typography variant="body2" >{record.causale_addebito ? record.causale_addebito.descrizione : undefined}</Typography>
                                    </Grid>
                                    <Grid className={classes.innergrid} item xs={3}>
                                        <Typography className={classes.title} color="textSecondary" variant="body1" >{translate('resources.devices.fields.note_addebito')}</Typography>
                                        <Typography variant="body2" >{record.note_addebito}</Typography>
                                    </Grid>
                                </>)}
                                <Grid className={classes.innergrid} item xs={3}>
                                    <Typography className={classes.title} color="textSecondary" variant="body1" >{translate('resources.devices.fields.contatore')}</Typography>
                                    <Typography variant="body2" >{record.contatore ? record.contatore : 0}</Typography>
                                </Grid>
                                <Grid className={classes.innergrid} item xs={3}>
                                    <Typography className={classes.title} color="textSecondary" variant="body1" >{translate('resources.devices.fields.reverse.descrizione')}</Typography>
                                    <Typography variant="body2" >{record.reverse ? record.reverse.descrizione : undefined}</Typography>
                                </Grid>
                                <Grid className={classes.innergrid} item xs={3}>
                                    <Typography className={classes.title} color="textSecondary" variant="body1" >{translate('resources.devices.fields.post_delivery')}</Typography>
                                    <Typography variant="body2" >{record.post_delivery}</Typography>
                                </Grid>
                                <Grid className={classes.innergrid} item xs={3}>
                                    <Typography className={classes.title} color="textSecondary" variant="body1" >{translate('resources.devices.fields.status_collaudo_one')}</Typography>
                                    <Typography variant="body2" >{record.status_collaudo_one ? record.status_collaudo_one.descrizione : undefined}</Typography>
                                </Grid>
                                {(permissions === 'approvatore') && (<>
                                    <Grid className={classes.innergrid} item xs={3}>
                                        <Typography className={classes.title} color="textSecondary" variant="body1" >{translate('resources.devices.fields.tipo_inserimento')}</Typography>
                                        <Typography variant="body2" >{record.status_collaudo_one ? record.tipo_inserimento : undefined}</Typography>
                                    </Grid>
                                </>)}
                            </Grid>
                        </CustomTabPanel>
                        <CustomTabPanel value={value} index={3}>
                            <Grid container spacing={1}>
                                <Grid className={classes.innergrid} item xs={3}>
                                    <Typography className={classes.title} color="textSecondary" variant="body1" >{translate('resources.devices.fields.impianto_regman')}</Typography>
                                    <Typography variant="body2">{record.impianto_regman}</Typography>
                                </Grid>
                                <Grid className={classes.innergrid} item xs={3}>
                                    <Typography className={classes.title} color="textSecondary" variant="body1" >{translate('resources.devices.fields.serial_number_cpe')}</Typography>
                                    <Typography variant="body2" >{record.serial_number_cpe}</Typography>
                                </Grid>
                                <Grid className={classes.innergrid} item xs={3}>
                                    <Typography className={classes.title} color="textSecondary" variant="body1" >{translate('resources.devices.fields.importo_u0009t')}</Typography>
                                    <Typography variant="body2" >{record.importo_u0009t}</Typography>
                                </Grid>
                                <Grid className={classes.innergrid} item xs={3}>
                                    <Typography className={classes.title} color="textSecondary" variant="body1" >{translate('resources.devices.fields.wr_collaudo_one')}</Typography>
                                    <Typography variant="body2" >{record.wr_collaudo_one}</Typography>
                                </Grid>
                                <Grid className={classes.innergrid} item xs={3}>
                                    <Typography className={classes.title} color="textSecondary" variant="body1" >{translate('resources.devices.fields.impianto_collaudo_one')}</Typography>
                                    <Typography variant="body2" >{record.impianto_collaudo_one}</Typography>
                                </Grid>
                                <Grid className={classes.innergrid} item xs={3}>
                                    <Typography className={classes.title} color="textSecondary" variant="body1" >{translate('resources.devices.fields.data_collaudo_one')}</Typography>
                                    <Typography variant="body2" >{returnDate(record.data_collaudo_one)}</Typography>
                                </Grid>
                            </Grid>
                        </CustomTabPanel>
                        <Grid container justifyContent="space-between"  >
                            <Grid className={classes.innergrid} item xs={10}>

                            </Grid>
                            <Grid className={classes.innergrid} item xs={2}>
                                <Grid container>
                                    <Grid item xs={6}>
                                        <FileListButton record={record} permissions={permissions} resource='devices' />
                                    </Grid>
                                    <Grid item xs={6}>
                                        <NoteButton record={record} permissions={permissions} />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </>
                );
            }}
        </ShowController >
    )
};


function returnDate(field) {
    if (field !== undefined && field !== null) {
        return new Date(field).toLocaleString('it-IT');
    }
    else {
        return "";
    }
}
export default DeviceShow;